<template>
	<view class="box">
		<view class="box-item" @click="jump">
			<view class="box-item-table">修改密码</view>
			<image src="/static/icon/ar_map@2x.png" mode="widthFix"></image>
		</view>
	</view>
</template>

<script>
	export default {
		methods: {
			jump() {
				uni.navigateTo({
					url: '/shop/pages/change-password/change-password'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		padding: 0 30rpx;
		box-sizing: border-box;
		
		.box-item {
			width: 100%;
			height: 102rpx;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1rpx solid #ececec;
			.box-item-table{
				font-weight: 400;
				font-size: 30rpx;
				color: #222222;
			}
			image{
				height: 20rpx;
				width: 20rpx;
			}
		}
	}
</style>